export default __webpack_public_path__ + "static/media/globe.8bc16e79.jpg";